import React from 'react'
import './App.css'
import RoutesRender from './components/Routes/RenderRoutes'
import { Provider } from 'react-redux'
import { store } from './redux/store'
import 'bootstrap/dist/css/bootstrap.min.css'
import { AuthProvider } from './routes/AuthContext'
import { NotificationProvider } from './contexts/notificationContext'

function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <NotificationProvider>
          <RoutesRender></RoutesRender>
        </NotificationProvider>
      </AuthProvider>
    </Provider>
  )
}

export default App
